// Private-event pages carry a bearer-style token in the path (/evento-privato/:token, /partecipa/:token,
// /partecipa/gestisci/:manageToken) and a payment reference in ?pagamento=. Anything that leaves the browser
// for analytics / error reporting uses the route pattern instead.
const PATTERNS = [[/\/api\/v1\/private\/[^/?#\s"']+/g, "/api/v1/private/:token"], [/\/api\/v1\/participation\/manage\/[^/?#\s"']+/g, "/api/v1/participation/manage/:manageToken"], [/\/api\/v1\/participation\/(?!manage[/?#]|manage$)[^/?#\s"']+/g, "/api/v1/participation/:token"], [/\/evento-privato\/[^/?#\s"']+/g, "/evento-privato/:token"], [/\/partecipa\/gestisci\/[^/?#\s"']+/g, "/partecipa/gestisci/:manageToken"], [/\/partecipa\/(?!gestisci(?:[/?#]|$))[^/?#\s"']+/g, "/partecipa/:token"], [/([?&])pagamento=[^&#\s"']*/g, "$1pagamento=:ref"]];
export const scrubTokenUrl = value => {
  if (typeof value !== "string" || value.indexOf("/api/v1/") === -1 && value.indexOf("/evento-privato/") === -1 && value.indexOf("/partecipa/") === -1 && value.indexOf("pagamento=") === -1) {
    return value;
  }
  return PATTERNS.reduce((text, _ref) => {
    let [re, replacement] = _ref;
    return text.replace(re, replacement);
  }, value);
};

/** Sentry event: request URL, transaction, breadcrumbs (navigation / fetch / exponea location). */
export const scrubSentryEvent = event => {
  if (!event) return event;
  if (event.request && event.request.url) event.request.url = scrubTokenUrl(event.request.url);
  if (event.request && event.request.headers && event.request.headers.Referer) {
    event.request.headers.Referer = scrubTokenUrl(event.request.headers.Referer);
  }
  if (event.transaction) event.transaction = scrubTokenUrl(event.transaction);
  if (Array.isArray(event.breadcrumbs)) event.breadcrumbs = event.breadcrumbs.map(scrubBreadcrumb);
  return event;
};
export const scrubBreadcrumb = crumb => {
  if (!crumb) return crumb;
  if (crumb.message) crumb.message = scrubTokenUrl(crumb.message);
  if (crumb.data) {
    Object.keys(crumb.data).forEach(key => {
      if (typeof crumb.data[key] === "string") crumb.data[key] = scrubTokenUrl(crumb.data[key]);
    });
  }
  return crumb;
};

/** True on the token pages: analytics and Replay stay off there (the URL itself is the credential). */
export const isPrivateTokenPath = pathname => typeof pathname === "string" && (pathname.startsWith("/evento-privato/") || pathname.startsWith("/partecipa/"));

/** Sentry transaction: name, request url, span descriptions / urls of the private API calls. */
export const scrubSentryTransaction = event => {
  scrubSentryEvent(event);
  if (event && Array.isArray(event.spans)) {
    event.spans.forEach(span => {
      if (span.description) span.description = scrubTokenUrl(span.description);
      if (span.data) {
        Object.keys(span.data).forEach(key => {
          if (typeof span.data[key] === "string") span.data[key] = scrubTokenUrl(span.data[key]);
        });
      }
    });
  }
  return event;
};